import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';
import './Header.css';

export default function Header() {
  const { t, lang, toggleLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: '#home', label: t.nav.home },
    { href: '#about', label: t.nav.about },
    { href: '#materials', label: t.nav.materials },
    { href: '#markets', label: t.nav.markets },
    { href: '#applications', label: t.nav.applications },
    { href: '#contact', label: t.nav.contact },
  ];

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''}`}>
      <div className="container site-header__inner">
        <a href="#home" className="site-header__brand" onClick={() => setOpen(false)}>
          <Logo size={40} />
          <span className="site-header__brand-text">
            <strong>{lang === 'ar' ? 'علم ليبيا' : 'Libyan Flag'}</strong>
            <small>{lang === 'ar' ? 'لاستيراد المواد الخام' : 'Raw Materials Import'}</small>
          </span>
        </a>

        <nav className={`site-header__nav ${open ? 'site-header__nav--open' : ''}`}>
          <ul>
            {links.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={() => setOpen(false)}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="site-header__actions">
          <button type="button" className="lang-toggle" onClick={toggleLang} aria-label="Switch language">
            {lang === 'ar' ? 'EN' : 'AR'}
          </button>
          <a href="#contact" className="btn btn--primary site-header__cta">
            {t.nav.cta}
          </a>
          <button
            type="button"
            className={`burger ${open ? 'burger--open' : ''}`}
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
